import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import ButtonBack from '../../components/ButtonBack';
import { FormGroup } from '../../components/Form';
import Input from '../../components/Form/Input';
import PasswordRules from '../../components/PasswordRules';
import Spacing from '../../components/Spacing';
import { SupportText } from '../../components/Support';
import Text from '../../components/Text';
import schemaPassword from '../../utils/schemas/password';
import { Container, ModalContainer } from './styles';
import ErrorMessage from '../../components/Form/ErrorMessage';
import { logout, resetPassword } from '../../services/user';
import Loading from '../../components/Loading';
import ErrorBox from '../../components/ErrorBox';
import m from '../../utils/messages';

const Modal = ({ onConfirm }) => {
  return (
    <ModalContainer>
      <Text variant="regular" align="center">
        Sua senha não possui os requisitos de segurança para o novo site.<br/><br/>Por favor, redefina sua senha.
      </Text>

      <Button text="Ok" onClick={onConfirm} variant="buttonSecondary" />
      <SupportText />
    </ModalContainer> 
  )
}

const PasswordCreate = ({ withResetModal = false }) => {
  const [modalOk, setModalOk] = useState(!withResetModal);
  const history = useHistory();

  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if(!sessionStorage.getItem('@resetToken@')) {
      history.replace('/login');
    } else {
      setShow(true);
    }
  }, [history])

  const handleSubmit = async (formData, { setSubmitting, isSubmitting }) => {
    if(isSubmitting || success) {
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      try {
        await logout();
      } catch {}
      const data = await resetPassword(formData);
      setSuccess(true);
      window.location.href = data?.redirectTo;
    } catch (err) {
      if (err?.response?.status === 401) {
        history.replace('/login');
      } else if(err?.response?.data?.message) {
        setError(err?.response?.data?.message);
      } else {
        setError(m('internalError'));
      }
    }
    setSubmitting(false);
  }

  if(!show) {
    return <></>;
  }
  
  return (
    <>
      <ButtonBack onClick={() => history.goBack()} />
      {modalOk ? (
        <Container>
          {success && <Loading position="fixed" />}
          <Text variant="title1" align="center">Crie uma senha para continuar</Text>
          <Spacing size={24} />
          <ErrorBox error={error} />
          <Formik 
            initialValues={{ password: '', password_confirmation: '' }} 
            validationSchema={schemaPassword} 
            onSubmit={handleSubmit} 
          >
            {({ isSubmitting }) => (
              <Form className="login__form form">
                <FormGroup>
                  <Input name="password" type="password" label="Cria uma senha" />
                  <ErrorMessage name="password" />
                </FormGroup>
                <Spacing size={24} />
                <FormGroup>
                  <Input name="password_confirmation" type="password" label="Confirme sua senha" />
                  <ErrorMessage name="password_confirmation" />
                </FormGroup>
                <Spacing size={40} />
                <PasswordRules />
                <Button variant="buttonPrimary" text="Cadastrar" type="submit" loading={isSubmitting} />
              </Form>
            )}
          </Formik>
          <SupportText />
        </Container>
      ) : (
        <Modal onConfirm={() => setModalOk(true)} />
      )} 
    </>
  );
}

export default PasswordCreate
